document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.benefit-header');

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const targetId = this.getAttribute('data-toggle');
        const content = document.getElementById('content-' + targetId.split('-')[1]);
        const chevron = document.getElementById('chevron-' + targetId.split('-')[1]);

        if (content.classList.contains('open')) {
          content.classList.remove('open');
          chevron.classList.add('rotated');
        } else {
          content.classList.add('open');
          chevron.classList.remove('rotated');
        }
      });
    });
});